import PropTypes from "prop-types";
import FilterOut from "../NotFound/FilterOut";
import styles from "./ProductList.css";
import ResultsProgressOverlay from "./ResultsProgressOverlay";
import renderProducts from "./renderProducts";

const ListBody = ({
  isLoading,
  pages,
  tileToFocus,
  offset,
  advert,
  faceAndBodyCarousel,
  ...rest
}) => (
  <div className={styles.productList}>
    {isLoading && <ResultsProgressOverlay />}
    {pages.length ? (
      renderProducts({
        pages,
        tileToFocus,
        offset,
        advert,
        faceAndBodyCarousel,
        ...rest
      })
    ) : (
      <FilterOut />
    )}
  </div>
);

ListBody.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.object).isRequired,
  offset: PropTypes.object.isRequired,
  tileToFocus: PropTypes.shape({
    first: PropTypes.bool,
    last: PropTypes.bool,
    pageNumber: PropTypes.number
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  advert: PropTypes.func,
  faceAndBodyCarousel: PropTypes.func
};

export default ListBody;
